import type { ReactElement } from 'react';
import { MarketOverviewPage } from '../../pages/MarketOverviewPage';

/**
 * Market Overview adapted into the mobile shell.
 * Same page as desktop; shell provides viewport height.
 */
export function MobileMarketTab(): ReactElement {
  return (
    <div className="h-full min-h-0 flex flex-col overflow-hidden">
      <MarketOverviewPage />
    </div>
  );
}
